/* eslint-disable max-lines */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as _ from 'lodash';
import * as moment from 'moment';
import { CookieService } from 'ngx-cookie-service';

import { Observable, Subject } from 'rxjs';
import {
  UserGroup,
  UserResponse,
  CompanyDetails,
} from '../interfaces/base-core-services.interface';
import { UserInfo } from '../store/base.action';
import { BaseSharedState } from '../store/base.state';
import { EnvironmentService } from './environment.service';
import { HttpClient } from "@angular/common/http";
import { LoadClm } from '@shared-store/clm.action';

@Injectable({
  providedIn: 'root',
})
export class UserInfoService {
  private readonly CONST = {
    TOKEN: 'app-token',
    USER: 'user-info',
    ROLES: 'roles',
    SCOPE: 'app-roles',
    USER_NAME: 'userName',
    USER_TYPE: 'userType',
    CUSTOMER_ID: 'customerId',
    ORG_ID: 'orgId',
    PORT_CODE:'portCode',
    PORT_NAME:'portName'
  };
  private cookiesExpires: Date | undefined;
  private userInfo$ = new Subject<any>();
  private userLogout$ = new Subject<any>();
  constructor(
    private cookie: CookieService,
    private store: Store,
    private env: EnvironmentService,
    private http: HttpClient
  ) {}

  setUserToken(token: string, expiresIn?: number | undefined) {
    const envVal: any = this.env.getEnvironment();
    if (!envVal.production) {
      this.cookie.set(
        btoa(this.CONST.TOKEN),
        token,
        this.getCookiesExpires(expiresIn)
      );
    } else {
      this.cookie.set(
        btoa(this.CONST.TOKEN),
        token,
        this.getCookiesExpires(expiresIn),
        window.location.pathname,
        window.location.hostname,
        true,
        'None'
      );
    }
  }

  getCookiesExpires(expiresIn?: moment.DurationInputArg1) {
    if (_.isEmpty(this.cookiesExpires)) {
      if (_.isEmpty(expiresIn)) {
        expiresIn = 36000;
      }
      const date = moment(new Date()).add(expiresIn, 'seconds');
      this.cookiesExpires = new Date(date.toString());
      return this.cookiesExpires;
    } else {
      return this.cookiesExpires;
    }
  }

  getUserToken() : any {
    const userInfo = this.getUserInfo();
    if (userInfo && userInfo.token) {
      return userInfo.token;
    } else {
      return this.cookie.get(btoa(this.CONST.TOKEN));
      // return sessionStorage.getItem('token');
    }
  }

  geRefreshToken() : any {
    const userInfo = this.getUserInfo();
    if (userInfo && userInfo.refreshToken) {
      return userInfo.refreshToken;
    } else {
      return sessionStorage.getItem('refreshToken');
    }
  }

  getCsrfToken() : string {
    const tokenKey = "XSRF-TOKEN";

    if (this.cookie.check(tokenKey)){
      return this.cookie.get(tokenKey);
    }
    return "";
  }

  getUserType() {
    const userInfo = this.getUserInfo();
    if (userInfo && userInfo.userType) {
      return userInfo.userType;
    } else {
      return atob(this.cookie.get(btoa(this.CONST.USER_TYPE)));
    }
  }

  setUserInfo(user: UserResponse) {
    if (user.group && _.find(user.group, { id: 'TaskManager' }) !== undefined) {
      user.isAdmin = true;
    }
    this.store.dispatch(new UserInfo(this.CONST.USER, JSON.stringify(user)));
    this.userInfo$.next(user);
    if(user.companyDetails){
      this.store.dispatch(new LoadClm())
    }
  }

  setUserInfoTab(user: UserResponse) {
    this.setUserInfo(user);
    this.setUserType(user.userType ? user.userType : "");
    this.setUserName(user.userName ? user.userName : "");
  }

  setCustomRole(role: any) {
    this.store.dispatch(new UserInfo(this.CONST.ROLES, JSON.stringify(role)));
  }
  setDashboardList(userId: any) {
    this.store.dispatch(new UserInfo('dashboardID', JSON.stringify(userId)));
  }

  updateUserDefaultCompany(data: CompanyDetails) : void {
    const user = this.getUserInfo();
    if(data && user){
      user.customerId = data.accountNo;
      user.orgId = data.clientId.toString();
      user.orgnaizationName = data.clientName;
      user.companyDetails = data;
      this.setUserInfo(user);
    }
  }

  getDashboardList() {
    const userInfo = this.store.selectSnapshot<any>(
      (state: BaseSharedState) => state['baseShared'].userInfo
    );
    if (userInfo['dashboardID']) return JSON.parse(userInfo['dashboardID']);
    else return [];
  }

  getDashboardFilters(id?: any) {
    const obj = this.getDashboardList();
    const index = obj.dashboardList.findIndex((itm: any) => itm.id == id);
    return obj.dashboardList[index].filters;
  }

  setUserGroupInfo(groups: UserGroup[]) {
    const user = this.getUserInfo();
    if (!_.isEmpty(groups) && user) {
      groups.forEach((g) => {
        g.text = g.name;
        g.value = g.id;
      });
      user.group = groups;
      this.setUserInfo(user);
    }
  }

  getUserGroups(): UserGroup[] | undefined  {
    const user = this.getUserInfo();
    return (user) ? user.group : undefined;
  }

  getUserInfo(): UserResponse | any {
    const userInfo = this.store.selectSnapshot<any>(
      (state: BaseSharedState) => state['baseShared']?.userInfo
    );
    if (userInfo[this.CONST.USER])
      return <UserResponse>JSON.parse(userInfo[this.CONST.USER]);
    else return undefined;
  }

  getUserInfo$() {
    return this.userInfo$.asObservable();
  }

  getActivityGroup(): any {
    const user = this.getUserInfo();
    return (user) ? user.licenseActivityGroup : [];
  }
  getUserName(): string {
    const userInfo = this.getUserInfo();
    let userName = '';

    if (userInfo && userInfo.userName) {
      userName = userInfo.userName;
    } else {
      userName = atob(this.cookie.get(btoa(this.CONST.USER_NAME)));
    }

    return (_.isEmpty(userName) || userName == 'undefined') ? '' : userName;
  }

  setUserName(userName: string) {
    const envVal: any = this.env.getEnvironment();
    if (!envVal.production) {
      this.cookie.set(btoa(this.CONST.USER_NAME), btoa(userName));
    } else {
      this.cookie.set(
        btoa(this.CONST.USER_NAME),
        btoa(userName),
        this.getCookiesExpires(),
        window.location.pathname,
        window.location.hostname,
        true,
        'None'
      );
    }
  }

  setUserType(userType: string) {
    const envVal: any = this.env.getEnvironment();
    if (!envVal.production) {
      this.cookie.set(btoa(this.CONST.USER_TYPE), btoa(userType));
    } else {
      this.cookie.set(
        btoa(this.CONST.USER_TYPE),
        btoa(userType),
        this.getCookiesExpires(),
        window.location.pathname,
        window.location.hostname,
        true,
        'None'
      );
    }
  }

  setCustomerIdAndOrgId(user: UserResponse) {
    const envVal: any = this.env.getEnvironment();
    if (!envVal.production) {
      this.cookie.set(
        btoa(this.CONST.CUSTOMER_ID),
        btoa(String(user.customerId))
      );
      this.cookie.set(btoa(this.CONST.ORG_ID), btoa(String(user.orgId)));
    } else {
      this.cookie.set(
        btoa(this.CONST.CUSTOMER_ID),
        btoa(String(user.customerId)),
        this.getCookiesExpires(),
        window.location.pathname,
        window.location.hostname,
        true,
        'None'
      );
      this.cookie.set(
        btoa(this.CONST.ORG_ID),
        btoa(String(user.orgId)),
        this.getCookiesExpires(),
        window.location.pathname,
        window.location.hostname,
        true,
        'None'
      );
    }
  }

  getUserCustomerId(): string {
    const user = this.getUserInfo();
    return (!user) ? '' : String(user.customerId);
  }

  getUserOrgId(): string {
    const user = this.getUserInfo();
    return (!user) ? '' : String(user.orgId);
  }

  getUserOrgName(): string {
    const user = this.getUserInfo();
    return (!user) ? '' : String(user.orgnaizationName);
  }

  isUserAdmin(): boolean {
    const userInfo = this.getUserInfo();
    if (userInfo && userInfo.userType) {
      return userInfo.userType === 'consumer_user' ? false : true;
    } else {
      return atob(this.cookie.get(btoa('userType'))) == 'consumer_user'
        ? false
        : true;
    }
  }

  getUserEmail(): string {
    const user = this.getUserInfo();
    return (!user) ? '' : String(user.email);
  }

  getUserFullName(): string {
    const user = this.getUserInfo();
    return (!user) ? '' : String(user.customerName);
  }
  getUserScope(pageID: any, menuId: any): string[] {
    const userScope = JSON.parse(
      String(localStorage.getItem(this.CONST.SCOPE))
    );
    let scope: any;
    userScope.forEach((element: any) => {
      if (element.operationName == pageID) {
        element.operationList.forEach((subElement: any) => {
          if (subElement.subList == menuId) scope = subElement.role;
        });
      }
    });

    return scope;
  }

  getUserRole(pageID: any): any {
    console.log(pageID);
    const userScope = JSON.parse(
      String(localStorage.getItem(this.CONST.SCOPE))
    );
    let scope;
    userScope.forEach((element: any) => {
      if (element.operationName.toLowerCase() == pageID) {
        scope = element.operationName.toLowerCase();
      }
    });
    return scope;
  }

  getUserActionRole(subMenu: any): any {
    const userScope = JSON.parse(
      String(localStorage.getItem(this.CONST.SCOPE))
    );
    let scope;
    userScope.forEach((element: any) => {
      element.operationList.forEach((element: any) => {
        if (element.subList.toLowerCase() == subMenu) {
          scope = element.subList.toLowerCase();
        }
      });
    });
    return scope;
  }

  getUserLogout$() {
    return this.userLogout$.asObservable();
  }

  userLogout(msg: string) {
    this.userLogout$.next(msg);
  }

  setSessionCookies() {
    const userInfo = this.getUserInfo();
    if (userInfo) {
      this.setUserToken(String(userInfo.token), userInfo.expiresIn);
      this.setUserType(String(userInfo.userType));
      this.setUserName(String(userInfo.userName));
      this.setCustomerIdAndOrgId(userInfo);
      this.setPortTypeAndPortCode(userInfo)
    }
  }

  setPortTypeAndPortCode(user:UserResponse){
    const envVal: any = this.env.getEnvironment();
    if (!envVal.production) {
      this.cookie.set(btoa(this.CONST.PORT_CODE), btoa(String(user.portCode)));
      this.cookie.set(btoa(this.CONST.PORT_NAME), btoa(String(user.portName)));
    } else {
      this.cookie.set(
        btoa(this.CONST.PORT_CODE),
        btoa(String(user.portCode)),
        this.getCookiesExpires(),
        window.location.pathname,
        window.location.hostname,
        true,
        'None'
      );
      this.cookie.set(
        btoa(this.CONST.PORT_NAME),
        btoa(String(user.portName)),
        this.getCookiesExpires(),
        window.location.pathname,
        window.location.hostname,
        true,
        'None'
      );
    }
  }

  getPortCode(){
    const userInfo = this.getUserInfo();
    let portCode = '';

    if (userInfo && userInfo.userName) {
      portCode = userInfo.portCode;
    } else {
      portCode = atob(this.cookie.get(btoa(this.CONST.PORT_CODE)));
    }

    return (_.isEmpty(portCode) || portCode == 'undefined') ? '' : portCode;
  }
  getPortName(){
    const userInfo = this.getUserInfo();
    let portName = '';

    if (userInfo && userInfo.userName) {
      portName = userInfo.portName;
    } else {
      portName = atob(this.cookie.get(btoa(this.CONST.PORT_NAME)));
    }

    return (_.isEmpty(portName) || portName == 'undefined') ? '' : portName;
  }

  deleteCookies() {
    const envVal: any = this.env.getEnvironment();
    if (!envVal.production) {
      this.cookie.deleteAll();
    } else {
      this.cookie.deleteAll(window.location.pathname, window.location.hostname);
    }
  }

  get customerId(): number {
    return +atob(this.cookie.get(btoa(this.CONST.CUSTOMER_ID)));
  }
  get customerIdString(): string {
    return atob(this.cookie.get(btoa(this.CONST.CUSTOMER_ID)));
  }

  get orgId(): number {
    return +atob(this.cookie.get(btoa(this.CONST.ORG_ID)));
  }

  getDashboardToken(): Observable<unknown> {
    return this.http.get<any>("bireports/getEmbedToken");
  }

  getStandardReportToken(): Observable<unknown> {
    return this.http.get<any>(`bireports/standardReport/getReportData`);
  }
}
